/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t=(t,e)=>t.depth-e.depth;export{t as compareByDepth};
//# sourceMappingURL=compare-by-depth.js.map
